var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AppHeader',{on:{"navBarToggle":_vm.navBarToggle}}),_c('router-view',{attrs:{"scrollPos":_vm.scrollPos}}),_c('AppFooter'),_c('v-dialog',{on:{"before-open":_vm.beforeOpenModal}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }